import { useState } from 'react';
import SpaceCanvas from '../components/SpaceCanvas';
import SubNav from '../components/SubNav';

const CONTACT_EMAIL = 'av@mrdn.one';

export default function Access() {
  // idle | sending | sent | error
  const [status, setStatus] = useState('idle');

  // Delivery via FormSubmit.co relay (no backend needed). First real submission
  // sends a one-time activation email to av@mrdn.one — confirm it once and all
  // further requests arrive automatically. Falls back to a mailto draft on error.
  function onSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value.trim();
    const contact = form.contact.value.trim();
    const volume = form.volume.value.trim();
    const location = form.server_location.value.trim();
    const desc = form.description.value.trim();
    setStatus('sending');
    fetch('https://formsubmit.co/ajax/' + CONTACT_EMAIL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        _subject: 'Lander access request — ' + name,
        _template: 'box',
        'Company / name': name,
        'Contact': contact,
        'Expected TX volume': volume,
        'Server location': location,
        'Description': desc,
      }),
    })
      .then((r) => {
        if (!r.ok) throw new Error('relay error');
        return r.json();
      })
      .then(() => {
        setStatus('sent');
      })
      .catch(() => {
        setStatus('error');
        const subject = 'Lander access request — ' + name;
        const body =
          'Company / name: ' + name +
          '\nContact: ' + contact +
          '\nExpected TX volume: ' + volume +
          '\nServer location: ' + location +
          '\n\nDescription:\n' + desc;
        window.location.href =
          'mailto:' + CONTACT_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      });
  }

  const btnLabel =
    status === 'sending' ? 'TRANSMITTING…' : status === 'sent' ? 'TRANSMITTED ✓' : 'TRANSMIT REQUEST →';

  return (
    <>
      <SubNav label="LANDER ACCESS" />

      <div className="relative min-h-[calc(100vh-60px)] overflow-hidden">
        <SpaceCanvas variant="body" className="absolute inset-0 w-full h-full" />
        <div className="relative z-[1] max-w-[860px] mx-auto px-16 py-[88px] max-[780px]:px-[22px] max-[780px]:py-[52px]">
          <div className="font-mono text-[10px] font-normal tracking-[3px] text-haze/40 mb-5">CHART Nº 004 — ACCESS REQUEST</div>
          <h1 className="font-display text-[44px] font-bold text-ice m-0 max-[780px]:text-[clamp(30px,9vw,44px)]">Request Lander Access</h1>
          <div className="font-mono text-[14px] font-normal leading-[1.85] text-haze/55 mt-4 max-w-[620px]">
            Tell us who you are and what you’re building. The request goes straight to the desk — we’ll take it from there.
          </div>

          <form onSubmit={onSubmit} className="mt-12 p-[38px_36px] border border-solid border-haze/45 rounded-[2px] relative flex flex-col gap-[26px]">
            <div className="absolute -top-1.5 left-[30px] w-[11px] h-[11px] rounded-full bg-white shadow-[0_0_16px_rgba(255,255,255,0.9)]"></div>
            <div>
              <label htmlFor="f-name" className="field-label">COMPANY OR NAME</label>
              <input id="f-name" name="name" type="text" autoComplete="organization" required placeholder="Acme Trading / Jane Doe…" className="field" />
            </div>
            <div>
              <label htmlFor="f-contact" className="field-label">CONTACT · EMAIL / TELEGRAM / DISCORD</label>
              <input id="f-contact" name="contact" type="text" autoComplete="email" spellCheck="false" required placeholder="jane@acme.io / @jane…" className="field" />
            </div>
            <div className="grid grid-cols-2 gap-[26px] max-[780px]:grid-cols-1">
              <div>
                <label htmlFor="f-volume" className="field-label">EXPECTED TRANSACTION VOLUME</label>
                <input id="f-volume" name="volume" type="text" required placeholder="e.g. 500K TX / day, peak 60 TPS…" className="field" />
              </div>
              <div>
                <label htmlFor="f-location" className="field-label">SERVER LOCATION</label>
                <input id="f-location" name="server_location" type="text" required placeholder="e.g. Frankfurt, bare metal @ Equinix FR2…" className="field" />
              </div>
            </div>
            <div>
              <label htmlFor="f-desc" className="field-label">DESCRIPTION · WHAT DO YOU NEED THE LANDER FOR?</label>
              <textarea id="f-desc" name="description" required placeholder="Volumes, strategy type, current delivery paths, latency targets…" className="field resize-y min-h-[140px]"></textarea>
            </div>
            <button
              type="submit"
              disabled={status === 'sending'}
              className="btn-solid self-start disabled:opacity-60"
            >
              {btnLabel}
            </button>
            {status === 'sent' && (
              <div className="font-mono text-[12px] font-normal text-ice">Request transmitted — we’ll get back to you shortly.</div>
            )}
            {status === 'error' && (
              <div className="font-mono text-[12px] font-normal text-ember">Transmission failed — opening an email draft instead.</div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
